import { hooks } from '@approvalmax/utils';
import { useSelector } from 'modules/react-redux';
import { requestSelector } from 'pages/requestForm/selectors/pageSelectors';
import { useCallback, useState } from 'react';
import { useGetNetSuiteVendorCategories } from 'shared/data/webApp/v1';

export const useCategoriesItems = () => {
    const request = useSelector(requestSelector);

    const [enabled, setEnabled] = useState(false);
    const [query, setCategoriesQuery] = useState('');
    const queryDebounced = hooks.useDebounce(query, 500);

    const categoriesTrigger = useCallback(() => {
        setEnabled(true);
    }, []);

    const { data, isFetching: isCategoriesFetching } = useGetNetSuiteVendorCategories(
        {
            query: {
                companyId: request.companyId,
                query: queryDebounced,
                pageSize: 1000,
            },
        },
        {
            enabled,
            staleTime: 1000 * 60,
        }
    );

    return {
        categories: data?.values ?? [],
        isCategoriesFetching,
        categoriesTrigger,
        setCategoriesQuery,
    };
};
